import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import TabContainer from "Component/Common/TabContainer";
import Dashboard from "Module/Subscription/Recruit/Dashboard/index.js";
import HiringPipeline from "Module/Subscription/Recruit/HiringPipeline/index.js";
import TalentPool from "Module/Subscription/Recruit/TalentPool/index.js";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Requisition from "Module/Subscription/Recruit/Requisitions/index.js";
import Requisition1 from "Module/Subscription/Recruit/Requsition1/index";
import HiringPlan from "Module/Subscription/Recruit/HiringPlan/index";
import PageNotFound from "Component/NotFound/index";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class recruit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      // value: this.props.isrecruiter ? 0 : 1,
      value: 0,
      pagenotfounderror: false,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  // handleTabChange(value) {
  //   this.setState({
  //     value,
  //   });
  // }

  handleTabChange(url) {
    this.setState(
      {
        // value,
      },
      () => {
        this.props.history.push(`/app/recruit/${url}`);
      },
    );
  }

  componentDidMount() {
    const {
      history: {
        location: { pathname = "" },
      },
    } = this.props;

    if (
      (!this.props.isrecruiter ||
        !this.props.ishiringowner ||
        !this.props.ishiringmanager ||
        !this.props.isparticipant) &&
      pathname == "/app/recruit"
    ) {
      this.setState({ pagenotfounderror: true });
    }

    if (
      (this.props.isrecruiter ||
        this.props.ishiringowner ||
        this.props.ishiringmanager ||
        this.props.isparticipant) &&
      pathname == "/app/recruit"
    ) {
      this.props.history.push(`${this.props.match.url}/pipeline`);
    }

    // isrecruiter && pathname == "/app/recruit/"
    //   ? this.props.history.push(`${this.props.match.url}/pipeline`)
    //   : this.props.history.push(`${this.props.match.url}/hiring_plan`);
  }

  componentWillUnmount() {}

  render() {
    const { value } = this.state;
    const {
      history: {
        location: { pathname = "" },
      },
    } = this.props;
    return (
      <div>
        {this.state.pagenotfounderror ? (
          <PageNotFound />
        ) : (
          <div className="innerwrapper-full-width">
            <div className="common-menubar-header">
              <Tabs
                // value={value}
                // onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                scrollButtons="auto"
              >
                {/* <Tab label="Dashboard" onClick={() => this.handleTabChange(0)} /> */}
                {(this.props.isrecruiter ||
                  this.props.ishiringowner ||
                  this.props.ishiringmanager ||
                  this.props.isparticipant) && (
                  // this.props.isparticipant
                  <Tab
                    label="Hiring pipeline"
                    // onClick={() => this.handleTabChange(0)}
                    className={`tabheading ${
                      pathname.includes("/app/recruit/pipeline")
                        ? "active-tab1"
                        : "inactive-tab1"
                    } `}
                    onClick={() => this.handleTabChange("pipeline")}
                  />
                )}

                {(this.props.isrecruiter ||
                  this.props.ishiringowner ||
                  this.props.ishiringmanager) && (
                  <Tab
                    label="Hiring plan"
                    className={`tabheading ${
                      pathname.includes("/app/recruit/hiring_plan")
                        ? "active-tab1"
                        : "inactive-tab1"
                    } `}
                    onClick={() => this.handleTabChange("hiring_plan")}
                    // onClick={() => this.handleTabChange(1)}
                  />
                )}

                {(this.props.isrecruiter ||
                  this.props.ishiringowner ||
                  this.props.ishiringmanager) && (
                  <Tab
                    label="Requisition"
                    className={`tabheading ${
                      pathname.includes("/app/recruit/requisition")
                        ? "active-tab1"
                        : "inactive-tab1"
                    } `}
                    onClick={() => this.handleTabChange("requisition")}
                    // onClick={() => this.handleTabChange(2)}
                  />
                )}

                {this.props.isrecruiter && (
                  <Tab
                    label="Talent pool"
                    className={`tabheading ${
                      pathname.includes("/app/recruit/talent_pool")
                        ? "active-tab1"
                        : "inactive-tab1"
                    } `}
                    onClick={() => this.handleTabChange("talent_pool")}
                    // onClick={() => this.handleTabChange(3)}
                  />
                )}
              </Tabs>
              {(this.props.isrecruiter ||
                this.props.ishiringowner ||
                this.props.ishiringmanager ||
                this.props.isparticipant) && <div className="tab-border"></div>}
            </div>
            <div>
              {/* {value == 0 && (
            <TabContainer>
              <Dashboard />
            </TabContainer>
          )} */}

              {pathname.includes("/app/recruit/pipeline") && (
                <TabContainer>
                  <HiringPipeline {...this.state} {...this.props} />
                </TabContainer>
              )}

              {pathname.includes("/app/recruit/hiring_plan") && (
                <TabContainer>
                  <HiringPlan {...this.state} {...this.props} />
                </TabContainer>
              )}

              {pathname.includes("/app/recruit/requisition") && (
                <TabContainer>
                  <Requisition1 {...this.state} {...this.props} />
                </TabContainer>
              )}

              {pathname.includes("/app/recruit/talent_pool") && (
                <TabContainer>
                  <TalentPool {...this.state} {...this.props} />
                </TabContainer>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(recruit)));
